export const pathRoutes = {
  home: "/",

  // Dashboard
  transactions: "/transactions",
  insights: "/insights",
  accounts: "/accounts",
  settings: "/settings",
  accountDetail: "/company/:companyId/accounts/:accountId",
  companyDetail: "/company/:companyId",
  companyDetailAccounts: "/company/:companyId/accounts",
  companySettings: "/company/:companyId/settings",

  // Onboarding
  joinAppRoot: "/join/*",
  joinCompanyLookup: "/join/company-lookup",
  joinConnectBank: "/join/connect-bank",
  joinAuthorizeAccounts: "/join/authorize-accounts",

  // OPS / Internal Portal
  opsAppRoot: "/ops/*",
  opsSearch: "/ops/search",
  opsSelectRole: "/ops/select-role",
  opsPersonDetail: "/ops/person/:userId",
  opsClientsCompanyDetail: "/ops/clients/:documentId/details",
  opsClientsCompanyUsers: "/ops/clients/:documentId/users",
  opsClientsCompanyUsersDetail: "/ops/clients/:documentId/users/:userId",
  opsOnboarding: "/ops/onboarding",
  opsOnboardingDetail: "/ops/onboarding/:documentId",
  opsOnboardingReview: "/ops/onboarding/:documentId/review",
} as const;

export type PathRoutes = (typeof pathRoutes)[keyof typeof pathRoutes];
